var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('img', {
    staticClass: "animation-bg",
    class: {
      'bg-opacity': _vm.bgOpacity
    },
    style: {
      height: _vm.imgHeight + 'px'
    },
    attrs: {
      "src": _vm.srcCover,
      "alt": ""
    }
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };